export const education = [
  {
    degree: "Bachelor of Engineering in Computer Science & Business Systems",
    institution: "Francis Xavier Engineering College",
    location: "Tirunelveli, Tamil Nadu",
    period: "2021 - 2025",
    cgpa: "8.6",
    highlights: [
      "Technical Lab Member",
      "Active in hackathons and technical events",
    ],
  },
  {
    degree: "Higher Secondary Certificate (HSC)",
    institution: "Tilak Vidhyalaya Higher Secondary School",
    location: "Tirunelveli, Tamil Nadu",
    period: "2019 - 2021",
    percentage: "92%",
    highlights: [
      "Computer Science Stream",
    ],
  },
];